module.exports = __webpack_public_path__ + "img/ocean-logo.aaa0fd55.webp";